import React, { PureComponent } from 'react'
import { Icon } from 'antd'
import * as styles from './index.scss'
import biezhen from 'assets/images/biezhen.png'

interface IProps {
  list: any[]
  people?: boolean
}
interface IState {
  index: number
  list: any[]
  showData: {}
}

class WorkPanel extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {
      index: 0,
      list: [],
      showData: {},
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.list !== state.list) {
      return {
        list: props.list,
        showData: props.list.length ? props.list[0] : {},
      }
    }
    return null
  }

  componentDidMount() {
    if (this.props.list.length) {
      return this.setState({
        list: this.props.list,
        showData: this.props.list[0],
      })
    }
  }

  // componentDidUpdate(props) {
  //   if (props.list !== this.state.list) {
  //     return this.setState({
  //       list: props.list,
  //       showData: props.list.length ? props.list[0] : {},
  //     })
  //   }
  // }

  toDetail = (id, type, content?) => {
    if (type === '1000104') {
      return window.open(`#/topicdetail/${id}`, '_blank')
    }
    if (type === '1000105') {
      return window.open(content, '_blank')
    }
    window.open(`#/course/${id}?type=${type}`)
  }

  handleSwitch = idx => {
    const { list } = this.props
    this.setState({
      index: idx,
      showData: list[idx],
    })
  }

  render() {
    const showPanel = ({
      article_id,
      article_type,
      entity_name,
      staff_name,
      desc,
      img,
    }) => (
      <div
        className={styles.workpanelShow}
        style={{
          flexDirection: this.props.people ? 'row-reverse' : null,
          backgroundColor: this.props.people && '#1890ff',
        }}
      >
        <div
          className={styles.workpanelShowAvatar}
          style={{
            width: this.props.people ? 596 : 532,
            height: this.props.people ? 404 : 361,
            padding: !this.props.people && 10,
          }}
        >
          <img
            src={biezhen}
            className={styles.brooch}
            style={{
              visibility: this.props.people ? 'hidden' : null,
            }}
          />
          <div
            style={{
              backgroundImage: `url(${img})`,
              backgroundPosition: 'top center',
              backgroundSize: '100%',
            }}
          />
        </div>
        <div
          className={
            this.props.people
              ? styles.workpanelShowBodyPeo
              : styles.workpanelShowBody
          }
          style={{
            paddingRight: !this.props.people && 14,
            paddingTop: !this.props.people && 4,
          }}
        >
          <div className={styles.workpanelShowName}>{staff_name || ''}</div>
          <div className={styles.workpanelShowTag}>
            <span>{entity_name || ''}</span>
          </div>
          <div className={styles.workpanelShowDesc} title={desc}>{`${desc ||
            ''}　`}</div>
          <div
            className={styles.workpanelShowBtn}
            style={{
              opacity: !article_id && 0.5,
              cursor: !article_id && 'no-drop',
            }}
            onClick={() =>
              article_id && this.toDetail(article_id, article_type)
            }
          >
            成长故事
            <Icon type="right" />
          </div>
        </div>
      </div>
    )
    const SelectItem = ({ cover, name, idx, total }) => (
      <div
        className={styles.workpanelItem}
        style={{
          justifyContent:
            idx === 0 ? 'flex-start' : idx === total - 1 ? 'flex-end' : null,
          height: !this.props.people && 86,
        }}
        onClick={() => this.handleSwitch(idx)}
        title={name}
      >
        <div
          className="mask"
          style={{
            visibility: idx === this.state.index ? 'hidden' : 'visible',
            width: this.props.people && '100%',
          }}
        />
        <div
          className="tip"
          style={{
            visibility: idx === this.state.index ? 'hidden' : 'visible',
            width: this.props.people && '100%',
          }}
        >
          <span>{name}</span>
        </div>
        <div
          className="avatar"
          style={{
            width: this.props.people && '100%',
            height: !this.props.people && 86,
          }}
        >
          <div
            style={{
              backgroundImage: `url(${cover})`,
              backgroundPosition: 'top center',
              backgroundSize: this.props.people && '100%',
            }}
          />
        </div>
      </div>
    )

    const selectGroup = _list => (
      <div
        className={styles.workpanelGroup}
        style={{
          marginTop: this.props.people && 4,
        }}
      >
        {_list.slice(0, 9).map((item, idx, arr) => (
          <div
            key={`si${idx}`}
            style={{
              width: `${100 / (this.props.people ? 6 : 9)}%`,
            }}
          >
            <SelectItem
              cover={item.img}
              name={item.staff_name}
              idx={idx}
              total={arr.length}
            />
          </div>
        ))}
      </div>
    )

    const { list, showData } = this.state

    return (
      <div className={styles.workpanel}>
        <div className={styles.workpanelInner}>
          {showPanel(showData as any)}
          {selectGroup(list)}
        </div>
      </div>
    )
  }
}

export default WorkPanel
